// Mock data for Ecumenical Center Church - UCCP

export const churchInfo = {
  name: "Ecumenical Center Church - UCCP",
  tagline: "Worship Together. Serve Together. Grow Together",
  location: "Zamboanga City",

  introduction: {
    title: "Welcome to Ecumenical Center Church \u2013 UCCP",
    content: "We are a faith community rooted in Christ\u2019s love and committed to justice, compassion, and service. At Ecumenical Center Church, everyone is welcomed with dignity and respect, regardless of background, age, or circumstance.\n\nWe gather to worship, learn, and serve in ways that are safe, inclusive, and nurturing. Our church upholds clear policies that promote mutual respect, child and youth protection, responsible leadership, and accountable stewardship. These guide how we care for one another and how we live out our faith together.\n\nWhether you are visiting for the first time or seeking a spiritual home, we invite you to journey with us in faith, dialogue, and service to the wider community.",
    mission: "  Our Vision: A responsible, empowered, self-reliant and caring community of Christian believers committed to the pursuit of a transformed church and society towards an abundant and meaningful life for all.\nOur Mission: Establishing and uniting the community of faith for the proclamation of the Gospel of our Lord Jesus Christ towards the transformation of both church and society.\n\nOur Goals:\n\u25CF To strengthen the faith community \u2013 which addresses our relationship within the faith community at all levels and in all aspects of its life and work \u2013 individual, collective, organizational and institutional\n\n\u25CF To enrich the life-work of communities where Local Churches are located \u2013 which speaks of the relationship of the Local Churches with the communities where they are situated and where issues are more effectively and meaningfully addressed\n\n\u25CF To deepen the impact of its collective response to societal issues and concerns \u2013 which reflects the relationship of the whole UCCP with the issues and concerns that effect the life-work of the whole nation, the global community and all of creation\n"
  },

  services: {
    title: "Our Services",
    schedule: [
    {
      name: "Sunday Worship",
      time: "9:00 AM & 11:00 AM",
      description: "Join us for inspiring worship, meaningful messages, and uplifting music."
    },
    {
      name: "Prayer Meeting",
      time: "Wednesday 7:00 PM",
      description: "Gather with us for prayer, fellowship, and spiritual encouragement."
    },
    {
      name: "Bible Study",
      time: "Friday 6:30 PM",
      description: "Dive deeper into God's Word through interactive study and discussion."
    }]

  },

  history: {
    title: "Our History",
    content: "The Ecumenical Center Church - UCCP has been a beacon of faith and hope in our community for many years. Founded on the principles of unity, service, and love, our church has grown to become a vibrant spiritual home for many families.",
    milestones: [
    "Established as a center for ecumenical dialogue and worship",
    "Committed to the United Church of Christ in the Philippines mission",
    "Serving the Zamboanga City community with compassion",
    "Building bridges across denominations through faith and fellowship"]

  },

  events: [
  {
    id: 1,
    title: "Sunday Fellowship",
    date: "Every Sunday",
    time: "After Service",
    description: "Join us for refreshments and fellowship after our morning worship service.",
    image: "https://customer-assets.emergentagent.com/job_0ca8b7ab-d422-4d3b-b565-d4e3e0d6ac03/artifacts/66ejwuyz_Sunday%20Fellowship%202.jpg"
  },
  {
    id: 2,
    title: "Community Outreach",
    date: "Monthly",
    time: "Various",
    description: "Serving our community through various outreach programs and initiatives.",
    image: "collage",
    images: [
      "https://customer-assets.emergentagent.com/job_0ca8b7ab-d422-4d3b-b565-d4e3e0d6ac03/artifacts/ryz248nv_community%20outreach.jpg",
      "https://customer-assets.emergentagent.com/job_0ca8b7ab-d422-4d3b-b565-d4e3e0d6ac03/artifacts/e0wzlevt_community%20outreach%202.jpg"
    ]
  },
  {
    id: 3,
    title: "Youth Ministry",
    date: "Every Saturday",
    time: "4:00 PM",
    description: "Engaging activities and spiritual formation for our young people.",
    image: "https://customer-assets.emergentagent.com/job_0ca8b7ab-d422-4d3b-b565-d4e3e0d6ac03/artifacts/jjm4r4h9_CYF.jpg"
  }],


  contact: {
    address: "#27 Castillo Rd., Baliwasan, Zamboanga City, 7000, Philippines",
    email: "eccuccpzamboangacity@gmail.com",
    phone: "+63629916685",
    social: {
      facebook: "https://www.facebook.com/uccpzambo",
      youtube: "https://www.youtube.com/@uccpzambo",
      messenger: "https://m.me/uccpzambo"
    }
  },

  images: {
    hero: "https://customer-assets.emergentagent.com/job_90205a7e-4d6d-494e-8cef-9b429c5f743c/artifacts/1x7tlz9t_eccuccpchurchzc.jpg",
    community: "https://customer-assets.emergentagent.com/job_0ca8b7ab-d422-4d3b-b565-d4e3e0d6ac03/artifacts/8n1g6gue_Cover%20photo.jpg",
    fellowship: "https://images.unsplash.com/photo-1565813086292-604790c8a97b",
    worship: "https://images.unsplash.com/photo-1570786032462-2efc3ca8fccd",
    mission: "https://images.unsplash.com/photo-1529070538774-1843cb3265df"
  }
};

export const navigationLinks = [
{ name: "Home", path: "/" },
{ name: "About Us", path: "/about" },
{ name: "Our Services", path: "/services" },
{ name: "History", path: "/history" },
{ name: "Leadership", path: "/leadership" },
{ name: "Events", path: "/events" },
{ name: "Blog", path: "/blog" },
{ name: "Contact", path: "/contact" }];